import React, { useLayoutEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.css";
import "./assets/css/style.css";

import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-notifications/lib/notifications.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistedStore, store } from "./redux/store";
import { CookiesProvider } from "react-cookie";
import AdminToolsDataService from "../src/services/admin-tools.service";
import { IntlProvider } from "react-intl";
import { Spin, notification } from "antd";
import { PostHogProvider } from "@posthog/react";
import posthog, { initAnalytics } from "./analytics/posthog";

const messages = {
  en: { greeting: "GemFind" },
};
const locale = "en";

initAnalytics();

function Root() {
  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <PostHogProvider client={posthog}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistedStore}>
            <CookiesProvider>
              <IntlProvider locale={locale} messages={messages[locale]}>
                <App />
              </IntlProvider>
            </CookiesProvider>
          </PersistGate>
        </Provider>
      </PostHogProvider>
    </Spin>
  );
}

ReactDOM.render(<Root />, document.getElementById("root"));

reportWebVitals();
